import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';
import mergingReducer from './mergeState';
import getItemsLocal from './localList/getItems';
import updateItemsLocal from './localList/updateItems';
import updateItemsGlobal from './globalList/updateItems';
import getItemsGlobal from './globalList/getItems';
import userDetails from './userDetails/getDetails';
var localList = reduceReducers(getItemsLocal, updateItemsLocal);
var globalList = reduceReducers(getItemsGlobal, updateItemsGlobal);
export var reducers = {
  inherited: mergingReducer,
  localList: localList,
  globalList: globalList,
  userDetails: userDetails
};
export default combineReducers(reducers);